import { LogbookRecordMalfunction } from '@fleet-beat/api';
import { SelectOption } from '../models';
import { CombinedMalfunctionCode, CombinedMalfunctionOptions, DataDiagnosticOptions } from '../enums';

export function getMalfunctionLabels(malfunctions: LogbookRecordMalfunction[]): string[] {
  const malfunctionLabels: string[] = [];
  malfunctions.forEach((mf: LogbookRecordMalfunction) => {
    const mfOption: SelectOption = CombinedMalfunctionOptions.find((item: SelectOption) => mf.code === item.value);
    if (mfOption) {
      malfunctionLabels.push(mfOption.label);
    }
  });
  return [...new Set(malfunctionLabels)];
}

export function entityIsDataDiagnostic(code: CombinedMalfunctionCode): boolean {
  return DataDiagnosticOptions.some((item: SelectOption) => code === item.value);
}
